// src/utils/pixel.js
export function loadMetaPixelOnce(pixelId) {
  if (!pixelId) return;
  if (window.fbq || window.__pixelLoaded) return;
  window.__pixelLoaded = true;

  // Inject pixel script
  (function(f,b,e,v,n,t,s){
    if (f.fbq) return; n=f.fbq=function(){ n.callMethod ?
      n.callMethod.apply(n,arguments) : n.queue.push(arguments) };
    if (!f._fbq) f._fbq=n; n.push=n; n.loaded=!0; n.version='2.0';
    n.queue=[]; t=b.createElement(e); t.async=!0; t.src=v;
    s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  fbq('init', pixelId);
  fbq('consent', 'revoke'); // safe default; we’ll grant after user opts in
}
